<div class="count-input">
    <button [disabled]="count<=1" nz-button nzType="text" class="down" (click)="down()">-</button>
    <input nz-input readonly [(ngModel)]="count" />
    <button nz-button nzType="text" class="up" (click)="up()">+</button>
</div>
